import moment from 'moment'
import { ReferenceLine } from 'recharts'

function renderYearSeperators(data) {
  if (!data) return <g />

  const yearStarts = data
    .slice(1, data.length)
    .filter(d => d.date.includes('01-01T00:00:00') || d.date.includes('Jan 1'))

  return yearStarts.map(d => (
    <ReferenceLine
      key={d.date}
      x={d.date}
      yAxisId="left"
      stroke="#CACFD6"
      strokeDasharray={[5, 5]}
      strokeWidth={1}
      ifOverflow="hidden"
      label={({ viewBox }) => (
        <g
          transform-origin={`${viewBox.x + viewBox.width / 2} ${
            viewBox.y + viewBox.height / 2
          }`}
        >
          <rect
            x={viewBox.x + viewBox.width / 2}
            y={viewBox.y + 8}
            width={40}
            transform={`translate(-20, -8)`}
            height={16}
            fill="white"
          />
          <text
            dx={viewBox.x + viewBox.width / 2}
            dy={viewBox.y + 10}
            fill="#888888"
            dominant-baseline="middle"
            text-anchor="middle"
            fontSize={11}
          >
            {moment(d.date).format('YYYY')}
          </text>
        </g>
      )}
      labelPosition="insideTopRight"
    />
  ))
}

export default renderYearSeperators
